var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegalProceedings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1094 24.1406L41.4062 7.57812H44.4531V3.90625H25.5469V1.17188H28.2031V0H21.7187V1.17188H24.375V3.90625H5.54688V7.57812H8.59375L2.89062 24.1406H0.546875V24.6875C0.546875 28.2031 4.29688 32.1875 9.375 32.1875C14.4531 32.1875 18.2031 28.2031 18.2031 24.6875V24.1406H15.8594L10.2344 7.57812H24.4531V27.4219C23.4375 27.6562 22.6562 28.5156 22.5781 29.6094L21.3281 43.2812H15.0781L13.4375 46.9531H36.5625L34.9219 43.2812H28.6719L27.4219 29.6094C27.3437 28.5156 26.4844 27.6562 25.4687 27.4219V7.57812H39.6875L33.9844 24.1406H31.6406V24.6875C31.6406 28.2031 35.3906 32.1875 40.4688 32.1875C45.5469 32.1875 49.2969 28.2031 49.2969 24.6875V24.1406H47.1094ZM17.0312 25.3125C16.6406 28.125 13.5156 31.0938 9.375 31.0938C5.23438 31.0938 2.10938 28.125 1.71875 25.3125H17.0312ZM14.6875 24.1406H4.14063L9.375 8.75L14.6875 24.1406ZM6.71875 6.40625V5.07812H24.4531V6.40625H6.71875ZM34.2188 44.375L34.8438 45.7812H15.2344L15.8594 44.375H34.2188ZM26.4062 29.6875L27.6562 43.2812H22.5781L23.6719 29.6875C23.75 28.9844 24.2969 28.4375 25 28.4375C25.7812 28.4375 26.3281 28.9844 26.4062 29.6875ZM25.5469 6.40625V5.07812H43.2812V6.40625H25.5469ZM40.625 8.75L45.9375 24.1406H35.3125L40.625 8.75ZM40.625 31.0938C36.4844 31.0938 33.3594 28.125 32.9688 25.3125H48.2031C47.8906 28.125 44.6875 31.0938 40.625 31.0938Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6719 48.8281H6.40625V50H43.6719V48.8281Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalProceedings);
export default __webpack_public_path__ + "static/media/legalProceedings.d9ce1e082d40b03ef2807453c7e51339.svg";
export { ForwardRef as ReactComponent };